import {
  GETPRODUCTACCOUNT,
  CREATEPRODUCTACCOUNT,
  UPDATEPRODUCTACCOUNT,
  DELETEPRODUCTACCOUNT,
  GETPRODUCTACCOUNTHEAD,
  CREATEPRODUCTACCOUNTHEAD,
  UPDATEPRODUCTACCOUNTHEAD,
  DELETEPRODUCTACCOUNTHEAD,
  GETPRODUCTACCOUNTTYPE,
  CREATEPRODUCTACCOUNTTYPE,
  UPDATEPRODUCTACCOUNTTYPE,
  DELETEPRODUCTACCOUNTTYPE,
  GETPRODUCTACCOUNTSUBTYPE,
  CREATEPRODUCTACCOUNTSUBTYPE,
  UPDATEPRODUCTACCOUNTSUBTYPE,
  DELETEPRODUCTACCOUNTSUBTYPE,
  GETALLPRODUCTACCOUNTHEAD,
  GETALLPRODUCTACCOUNT,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // Setup Account Cases
    case GETPRODUCTACCOUNT:
      return {
        ...state,
        productaccountsList: action.payload.data,
      };
    case CREATEPRODUCTACCOUNT:
      return {
        ...state,
        productsetupAccountCreateStatus: action.payload.success,
      };
    case UPDATEPRODUCTACCOUNT:
      return {
        ...state,
        productsetupAccountUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTACCOUNT:
      return {
        ...state,
        productsetupAccountDeleteStatus: action.payload.success,
      };

    // Account Head Cases
    case GETPRODUCTACCOUNTHEAD:
      return {
        ...state,
        productaccountheadsList: action.payload.data,
      };
      case GETALLPRODUCTACCOUNT:
      return {
        ...state,
        allproductaccountList: action.payload.data,
      };
    case GETALLPRODUCTACCOUNTHEAD:
      return {
        ...state,
        allproductaccountheadsList: action.payload.data,
      };

    case CREATEPRODUCTACCOUNTHEAD:
      return {
        ...state,
        productaccountheadCreateStatus: action.payload.success,
      };
    case UPDATEPRODUCTACCOUNTHEAD:
      return {
        ...state,
        productaccountheadUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTACCOUNTHEAD:
      return {
        ...state,
        productaccountheadDeleteStatus: action.payload.success,
      };

    // Account Type Cases
    case GETPRODUCTACCOUNTTYPE:
      return {
        ...state,
        productaccounttypesList: action.payload.data,
      };
    case CREATEPRODUCTACCOUNTTYPE:
      return {
        ...state,
        productaccounttypeCreateStatus: action.payload.success,
      };
    case UPDATEPRODUCTACCOUNTTYPE:
      return {
        ...state,
        productaccounttypeUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTACCOUNTTYPE:
      return {
        ...state,
        productaccounttypeDeleteStatus: action.payload.success,
      };

    // Account SubType Cases
    case GETPRODUCTACCOUNTSUBTYPE:
      return {
        ...state,
        productaccountsubtypesList: action.payload.data,
      };
    case CREATEPRODUCTACCOUNTSUBTYPE:
      return {
        ...state,
        productaccountsubtypeCreateStatus: action.payload.success,
      };
    case UPDATEPRODUCTACCOUNTSUBTYPE:
      return {
        ...state,
        productaccountsubtypeUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTACCOUNTSUBTYPE:
      return {
        ...state,
        productaccountsubtypeDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
